import React from 'react';
import LocationTemplate from './LocationTemplate';

const ClintonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Clinton"
      stateName="North Carolina"
      countyName="Sampson"
      zipCodes={["28328"]}
      latitude={35.0057}
      longitude={-78.3303}
      population={8464}
      historicalFact="Established in 1852, named for Richard Clinton, a Revolutionary War officer."
      nearbyTowns={[
        "Fayetteville, NC",
        "Dunn, NC",
        "Warsaw, NC",
        "Rose Hill, NC",
        "Turkey, NC",
        "Garland, NC",
        "Newton Grove, NC",
        "Salemburg, NC"
      ]}
    />
  );
};

export default ClintonPage;